var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-thumbnail-container"},[_c('div',{staticClass:"video-thumbnail-content"},[_vm._t("video-thumbnail"),_c('div',{staticClass:"play-icon-overlay"},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-play")])],1)],2),_c('span',{staticClass:"video-title-container"},[_vm._t("video-title")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }